import { render, staticRenderFns } from "./tt.vue?vue&type=template&id=9a643e5c"
import script from "./tt.vue?vue&type=script&lang=js"
export * from "./tt.vue?vue&type=script&lang=js"
import style0 from "./tt.vue?vue&type=style&index=0&id=9a643e5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports